export class AxiosError extends Error {
	public statusCode: number;

	constructor(...params) {
		super(...params);

		// Set the prototype explicitly, this is required in some environments like Babel
		Object.setPrototypeOf(this, AxiosError.prototype);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, AxiosError);
		}

		const axiosError = params[0];
		const responseData = axiosError?.response?.data;
		const status = axiosError?.response?.status;
		const requestUrl = axiosError?.config?.url;
		const requestHeaders = axiosError?.config?.headers;

		// Build detailed error message
		let errorMessage = `HTTP ${status || 'Error'}`;

		// Add server error message if available
		if (responseData) {
			if (responseData.message) {
				errorMessage += `: ${responseData.message}`;
			}
			if (responseData.httpRequestId) {
				errorMessage += ` (RequestId: ${responseData.httpRequestId})`;
			}
			if (responseData.exceptionType) {
				errorMessage += ` | Exception: ${responseData.exceptionType}`;
			}
			// Check for errors array (alternative error format)
			const { errors } = responseData;
			if (errors && errors.length > 0) {
				const errorDetails = errors.map((error) => error?.detail).join(', ');
				errorMessage += ` | Details: ${errorDetails}`;
			}
		}

		// Add request details
		if (requestUrl) {
			errorMessage += ` | URL: ${requestUrl}`;
		}
		if (requestHeaders?.Hostname) {
			errorMessage += ` | Hostname Header: ${requestHeaders.Hostname}`;
		}

		this.name = 'AxiosError';
		this.statusCode = status;
		this.message = errorMessage;
	}
}
